export default __webpack_public_path__ + "static/media/5.2feca3dd.png";